if (!customElements.get('wlsn-comments-facet')) {
  class WLSNCommentsFacet extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.isLoading = false;

      this.classes = {
        loading: 'loading',
        facet: 'wlsn-comments-facet',
        loadingState: 'wlsn-loading-state',
      };

      this.bindMethods = {
        onPaginationChange: this._onPaginationChange.bind(this),
        onPopState: this._onPopState.bind(this),
      };
    }

    get elements() {
      return {};
    }

    connectedCallback() {
      this.addEventListener('wlsn:pagination:page-changed', this.bindMethods.onPaginationChange);
      window.addEventListener('popstate', this.bindMethods.onPopState);

      // On direct URL load with ?page=, fetch that page and scroll to comments
      const page = new URLSearchParams(window.location.search).get('page');
      if (page && page !== '1') {
        this._fetchAndUpdate(new URL(window.location.href)).then(() => {
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    disconnectedCallback() {
      this.removeEventListener('wlsn:pagination:page-changed', this.bindMethods.onPaginationChange);
      window.removeEventListener('popstate', this.bindMethods.onPopState);
    }

    async _onPaginationChange(event) {
      const url = new URL(event.detail.url);
      history.pushState({}, '', url.toString());
      this._fetchAndUpdate(url);
    }

    async _onPopState() {
      const url = new URL(window.location.href);
      const page = url.searchParams.get('page');
      if (page) {
        this._fetchAndUpdate(url);
      }
    }

    async _fetchAndUpdate(url) {
      // Prevent overlapping requests
      if (this.isLoading) {
        this._abort();
      }

      this.isLoading = true;
      this._setLoading();

      try {
        this.abortController = new AbortController();
        const res = await fetch(url.toString(), { signal: this.abortController.signal });
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newFacet = doc.querySelector(`${this.classes.facet}`);

        if (newFacet) {
          this.innerHTML = newFacet.innerHTML;
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('[WLSNCommentsFacet] Fetch error:', error);
        }
      } finally {
        this.isLoading = false;
        this._removeLoading();
      }
    }

    _abort() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
    }

    _setLoading() {
      this.classList.add(this.classes.loading);
      this.classList.add(this.classes.loadingState, true);
    }

    _removeLoading() {
      this.classList.remove(this.classes.loading);
      this.classList.remove(this.classes.loadingState);
    }
  }
  customElements.define('wlsn-comments-facet', WLSNCommentsFacet);
}
